import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './MenuSelection.module.css';

import { MenuSection } from './components/MenuSection';

const bindClasses = classNameBind.bind(styles);

const MenuSelection = ({
  items,
  name,
  value = '',
  dataId = 'MenuSelection',
  disabled = false,
  fixedHeight = undefined,
  onBlur = () => {},
  onChange = () => {},
}) => {
  const allItems = items.reduce((acc, curr) => (acc.concat(curr.sectionItems)), []);
  const selectedItem = allItems.find(sectionItem => (sectionItem.value === value));
  const selectedContent = selectedItem ? selectedItem.content : null;

  return (
    <div
      className={bindClasses('container', { fixedHeight })}
      data-ppuc-id={dataId}
    >
      <div className={bindClasses('left-section')} style={fixedHeight ? { height: fixedHeight } : {}}>
        {items.map(section => (
          <MenuSection
            key={section.sectionId}
            name={name}
            sectionId={section.sectionId}
            sectionLabel={section.sectionLabel}
            sectionItems={section.sectionItems}
            section={section}
            value={value}
            dataId={dataId}
            disabled={section.sectionDisabled || disabled}
            onChange={onChange}
            onBlur={onBlur}
          />
        ))}
      </div>
      <div className={bindClasses('right-section')} style={fixedHeight ? { height: fixedHeight } : {}}>
        {selectedContent}
      </div>
    </div>
  );
};

export { MenuSelection };
